import React, { useRef, useState } from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./TwilioConnectModal.module.scss";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { FormTextInput } from "@whatslly/ui-components/v2/FormElements/FormTextInput";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikErrors, FormikProps } from "formik";
import type { PartialRecord } from "@whatslly/commons/typescriptUtils";
interface RenamePhoneModalProps extends IModalInstance<{ apiKey: string; apiSecret: string; accountSid: string; authToken: string }> {
  apiKey: string;
  apiSecret: string;
  authToken: string;
  accountSid: string;
}

const BASE_DATA: { accountSid: string; apiKey: string; apiSecret: string; authToken: string } = {
  authToken: "",
  accountSid: "",
  apiKey: "",
  apiSecret: "",
};
type FormDataType = { accountSid: string; apiKey: string; apiSecret: string; authToken: string };
export const TwilioConnectModal: React.FC<RenamePhoneModalProps> = observer(({ closeModal }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<FormDataType>>(null);
  const [formikErrorHasErrors, setFormikErrorHasErrors] = useState(true);
  const validate = async (values: FormDataType) => {
    const errors: FormikErrors<PartialRecord<keyof FormDataType, string>> = {};
    if (!values.apiKey) {
      errors.apiKey = t("field_is_required");
    }
    if (!values.accountSid) {
      errors.accountSid = t("field_is_required");
    }
    if (!values.authToken) {
      errors.authToken = t("field_is_required");
    }
    if (!values.apiSecret) {
      errors.apiSecret = t("field_is_required");
    }
    Object.keys(errors).length > 0 ? setFormikErrorHasErrors(true) : setFormikErrorHasErrors(false);
    return errors;
  };

  const getFormValues = () => {
    return (formikContext.current?.values ?? {}) as FormDataType;
  };

  const onSubmit = async () => {
    closeModal(getFormValues());
  };
  return (
    <BaseModal
      header={<ModalHeader closeModal={closeModal}>{t("twilio_settings_page.title")}</ModalHeader>}
      closeModal={closeModal}
      className={styles.model}
      bodyClassName={styles.body}
      headerClassName={styles.header}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <FormElement initialValues={BASE_DATA} onSubmit={onSubmit} formikRef={formikContext} validate={validate}>
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("twilio_settings_page.cols.account_sid")} />
          <FormTextInput name={"accountSid"} paddingInline="none" />
        </div>
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("twilio_settings_page.cols.auth_token")} />
          <FormTextInput name={"authToken"} paddingInline="none" />
        </div>
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("twilio_settings_page.cols.api_sid")} />
          <FormTextInput name={"apiKey"} paddingInline="none" />
        </div>
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("twilio_settings_page.cols.api_secret")} />
          <FormTextInput name={"apiSecret"} paddingInline="none" />
        </div>
      </FormElement>
      <ModalButtons
        isSubmitDisabled={formikErrorHasErrors}
        testId="modal-buttons-submit-button"
        onCancel={closeModal}
        onSubmit={() => formikContext.current?.submitForm()}
      />
    </BaseModal>
  );
});
